/*
 * Adds a single complementary product to the cart when its own "Add" button
 * is clicked. Works with content that is loaded asynchronously by
 * <product-recommendations> via event delegation on the document.
 */
(function () {
  if (window.complementaryAddInitialized) return;
  window.complementaryAddInitialized = true;

  function getCart() {
    return document.querySelector('cart-notification') || document.querySelector('cart-drawer');
  }

  function setLoading(button, isLoading) {
    const spinner = button.querySelector('.complementary-card__add-spinner');
    if (isLoading) {
      button.classList.add('loading');
      button.setAttribute('aria-disabled', 'true');
      if (spinner) spinner.classList.remove('hidden');
    } else {
      button.classList.remove('loading');
      button.removeAttribute('aria-disabled');
      if (spinner) spinner.classList.add('hidden');
    }
  }

  function flashAdded(button) {
    const text = button.querySelector('.complementary-card__add-text');
    if (!text) return;
    const original = text.dataset.originalText || text.textContent;
    text.dataset.originalText = original;
    button.classList.add('is-added');
    text.textContent = '✓ Added';
    clearTimeout(button._addedTimeout);
    button._addedTimeout = setTimeout(() => {
      button.classList.remove('is-added');
      text.textContent = original;
    }, 1800);
  }

  document.addEventListener('click', function (event) {
    const button = event.target.closest('.complementary-card__add-button');
    if (!button) return;

    event.preventDefault();

    if (button.disabled || button.getAttribute('aria-disabled') === 'true') return;

    const variantId = button.dataset.variantId;
    if (!variantId) return;

    const cart = getCart();

    setLoading(button, true);

    const config = fetchConfig('javascript');
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    delete config.headers['Content-Type'];

    const formData = new FormData();
    formData.append('items[0][id]', variantId);
    formData.append('items[0][quantity]', 1);

    if (cart) {
      formData.append(
        'sections',
        cart.getSectionsToRender().map((section) => section.id)
      );
      formData.append('sections_url', window.location.pathname);
      if (typeof cart.setActiveElement === 'function') {
        cart.setActiveElement(document.activeElement);
      }
    }

    config.body = formData;

    fetch(`${routes.cart_add_url}`, config)
      .then((response) => response.json())
      .then((response) => {
        if (response.status) {
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            publish(PUB_SUB_EVENTS.cartError, {
              source: 'complementary-add',
              productVariantId: variantId,
              errors: response.errors || response.description,
              message: response.message,
            });
          }
          console.error('Complementary add to cart failed:', response.description || response.message);
          return;
        }

        if (cart) {
          cart.renderContents(response);
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'complementary-add', productVariantId: variantId });
          }
        } else {
          window.location = window.routes.cart_url;
          return;
        }

        flashAdded(button);

        if (button.dataset.closeBestsellersSubdrawer === 'true' && typeof window.closeCartDrawerBestsellersSubdrawer === 'function') {
          window.closeCartDrawerBestsellersSubdrawer();
        }
      })
      .catch((e) => {
        console.error(e);
      })
      .finally(() => {
        setLoading(button, false);
        const cartEl = getCart();
        if (cartEl && cartEl.classList.contains('is-empty')) cartEl.classList.remove('is-empty');
      });
  });
})();
